import imagesLoaded from 'imagesloaded';
import Masonry from 'masonry-layout';

// Social Feed
const container = $('.social_feed_block_container');
const grid = $('.social_feed_block_grid');
const moreButton = $('.social_feed_show_more');
const fade = $('.social_feed_more_fade');
const COLLAPSED_CONTAINER_HEIGHT = 800;

if (container.length) {
  imagesLoaded(grid, function () {
    const msnry = new Masonry('.social_feed_block_grid', {
      itemSelector: '.social_feed_block',
      gutter: 30,
    });
    checkIfHideShowMoreButton();
    msnry.on('layoutComplete', function (items) {
      // Reruns on window resize
      checkIfHideShowMoreButton();
    });
  });

  moreButton.on('click', function () {
    if (container.hasClass('expanded')) return;
    container.addClass('expanded');
    moreButton.hide();
    fade.hide();
  });

  function checkIfHideShowMoreButton() {
    const height = parseInt(grid.css('height'));
    if (height < COLLAPSED_CONTAINER_HEIGHT) {
      container.addClass('expanded');
      moreButton.hide();
      fade.hide();
      // container.css({ height: height + 35 + 'px' });
    } else {
      if (container.hasClass('expanded')) return;
      moreButton.show();
      fade.show();
    }
  }
}
